<template>
  <div
    class="essays-table-header d-flex justify-content-between align-items-center"
  >
    <div class="all-submissions">{{ $t("essays.allSubmissions") }}</div>

    <div class="d-flex align-items-center flex-gap-1">
      <div
        v-b-tooltip.hover.top
        :title="!selectedIds.length ? tooltipText : ''"
      >
        <eg-button
          type="secondary"
          right-icon="close"
          size="extra-small"
          :disabled="!selectedIds.length"
          @click="$emit('reset-selected')"
        >
          {{ $t("essays.countSelected", { count: selectedIds.length }) }}
        </eg-button>
      </div>

      <essay-actions
        :disabled="!selectedIds.length"
        class="desktop"
        :selected-all="selectedAll"
        :selected-ids="selectedIds"
        @export="$emit('export', $event)"
        @delete="$emit('delete', $event)"
      />
      <template
        v-if="!selectedIds.length && $route.params.id && !features.bulkImports"
      >
        <eg-button
          type="primary"
          size="extra-small"
          icon="plus-add-more-maximize"
          icon-size="extra-small"
          data-testid="grade-more-submissions-button"
          @click="onAddSubmissions"
        >
          {{ $t("essays.gradeMoreSubmissions") }}
        </eg-button>
        <eg-button
          type="ordinary"
          size="extra-small"
          icon="information"
          icon-size="extra-small"
          :aria-label="$t('essays.gradeMoreSubmissionsHint')"
          @click="
            $eventBus.$emit('onboarding:clicked:gradeMoreSubmissionsHint')
          "
        />
      </template>
    </div>
  </div>
</template>

<script>
import EssayActions from "./filters/essay_actions.vue";
import { onAddSubmissions } from "./essays_table_utils";
import CreateWorkspaceIntegrationModal from "@/views/dashboard/workspace-integration/modal/create-workspace-integration-modal.vue";
import { getUser } from "@/api";
import { mergeUserData } from "@/utils/userUtils";
import { PLATFORMS } from "@/constants";
import { mapGetters } from "vuex";

export default {
  name: "EssayTableHeader",
  components: {
    EssayActions,
  },
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    selectedAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("config", ["features"]),
    tooltipText() {
      return this.$t("essays.selectToUseAction");
    },
    isConnected() {
      switch (this.$route.params.workspaceKey) {
        case PLATFORMS.GOOGLE:
          return this.$store.getters.isGoogleConnected;
        case PLATFORMS.CANVAS:
          return this.$store.getters.isCanvasConnected;
        default:
          // TODO: DOUBLE CHECK why true works? ps. remove after the testing 4.2
          return true;
      }
    },
  },

  methods: {
    async onAddSubmissions() {
      if (!this.isConnected) {
        this.$egModal.show("create-workspace-integration-modal", {
          component: CreateWorkspaceIntegrationModal,
          props: {
            platformKey: this.$route.params.workspaceKey,
          },
          on: {
            onSuccess: () => this.updateUserData(),
          },
        });

        return;
      }

      await onAddSubmissions({
        workspaceKey: this.$route.params.workspaceKey,
        folderId: +this.$route.params.id,
      });

      this.$emit("submission-added");
    },

    async updateUserData() {
      const { data } = await getUser("me");
      const userData = mergeUserData(this, data);

      await this.$store.dispatch("setUser", userData);
    },
  },
};
</script>

<style lang="scss" scoped>
.essays-table-header {
  flex-wrap: wrap;
  border-radius: var(--radius-rd-400, 12px);
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 12px 16px;
}

.all-submissions {
  color: var(--color-text-neutral-on-white, #1c0f30);
  font-family: var(--typography-font-family-text-primary, Inter);
  font-size: var(--typography-font-size-fs-400, 16px);
  font-style: normal;
  font-weight: var(--typography-font-weight-fw-600, 600);
  line-height: 150%; /* 24px */
  letter-spacing: 0.3px;
}
</style>
